(() => {
  'use strict';
  const current = document.currentScript?.src || '';
  const base = current.slice(0, current.lastIndexOf('/') + 1);

  const loadCss = (name) => {
    if ([...document.styleSheets].some((sheet) => sheet.href?.includes(name))) return;
    const css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = `${base}${name}`;
    document.head.append(css);
  };

  loadCss('lyastone-signature-light-fixes.css');
  loadCss('lyastone-mobile-compact.css');

  const load = (name, done) => {
    const existing = [...document.scripts].find((script) => script.src?.includes(name));
    if (existing) {
      if (done) {
        if (existing.dataset.lyLoaded === 'true') done();
        else existing.addEventListener('load', done, { once: true });
      }
      return;
    }

    const script = document.createElement('script');
    script.src = `${base}${name}`;
    script.defer = true;
    if (done) script.addEventListener('load', done, { once: true });
    script.addEventListener(
      'load',
      () => {
        script.dataset.lyLoaded = 'true';
      },
      { once: true }
    );
    document.head.append(script);
  };

  load('lyastone-browser-quick-add.js', () => {
    load('lyastone-quick-add-bridge.js');
  });
  load('lyastone-mobile-merch.js');
  load('lyastone-product-purchase.pre-cart-drawer-integration.js', () => {
    load('lyastone-signature-light-integration.js');
  });
})();
